import { I as r } from "../../constants-DeVuDy8J.js";
import { openBlock as l, createElementBlock as n, normalizeClass as o, createElementVNode as i } from "vue";
import { _ as s } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const c = {
  name: "DtIconDialpadStar",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(r).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return r[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, u = ["aria-label", "data-qa", "aria-hidden"];
function m(e, t, d, p, _, a) {
  return l(), n("svg", {
    "aria-label": d.ariaLabel,
    class: o([a.iconSizeClass, "d-icon d-icon--dialpad-star"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Dialpad Star",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, [...t[0] || (t[0] = [
    i("path", {
      d: "M6.394 3.734c.064-.029.05-.138-.017-.153-1.01-.224-1.796-1.118-1.965-2.24-.011-.074-.142-.091-.17-.022-.434 1.34-1.375 2.389-2.627 2.9-.061.029-.049.13.017.146.986.237 1.751 1.115 1.923 2.215.011.072.131.089.159.02.501-1.401 1.46-2.454 2.68-2.866Z",
      fill: "currentColor"
    }, null, -1),
    i("path", {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      d: "M7.568 10.35c-1.292 0-2.22-1.034-2.22-2.449 0-1.415.928-2.44 2.22-2.44.6 0 1.173.3 1.427.69V3.629h1.055v6.63H8.995v-.607c-.254.39-.827.698-1.427.698Zm.172-.916c.682 0 1.192-.526 1.255-1.242v-.599c-.063-.717-.573-1.215-1.255-1.215-.764 0-1.31.607-1.31 1.514s.546 1.542 1.31 1.542Z",
      fill: "currentColor"
    }, null, -1)
  ])], 10, u);
}
const S = /* @__PURE__ */ s(c, [["render", m]]);
export {
  S as default
};
//# sourceMappingURL=dialpad-star.js.map
